import { IState } from 'legacy/lut/store'

export const selectFinSobSidePanelState = (state: IState) => state.partner360.finSobSidePanel
